import { Card, Divider, IconButton, Link, Typography, useTheme } from "@mui/material";
import { Treinamento } from "../../services/api/treinamentos";
import { Delete, Edit } from "@mui/icons-material";
import { EventoBarragem } from "../../services/api/company";
import { useApi } from "../../services";
import { useEffect, useState } from "react";
import { BarragemData, useUserContext } from "../../context";

export const CardTreinamento: React.FC<{
  onEdit?: (evento: EventoBarragem) => void;
  onRemove?: (treinamento: Treinamento) => void;
  treinamento: Treinamento;
  treinamentoAnterior?: Treinamento;
}> = ({ treinamento, treinamentoAnterior, onRemove, onEdit }) => {
  const { palette } = useTheme();
  const api = useApi();
  const user = useUserContext();

  const [barragem, setBarragem] = useState<BarragemData>();

  // Obtendo dados da barragem do simulado
  useEffect(() => {
    api.barragem.getBarragemById(treinamento.idBarragem).then(value => {
      if ('error' in value) return;
      setBarragem(value);
    });
  }, [treinamento]);

  const handleClick = () => {
    if (treinamento.file) window.open(treinamento.file, '_blank');
  };

  if (!user || "error" in user) return <Typography fontWeight={700} fontSize={18}>Sem Usuário</Typography>;

  return <Card sx={{
    padding: 2,
    gap: "5px",
    width: "18em",
    display: "flex",
    flexDirection: "column",
    bgcolor: palette.calendario.treinamentoCardColor,
  }}>
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Typography fontWeight={700} fontSize={18}>{`Treinamento${barragem?.nome ? ` em ${barragem.nome}` : ""}`}</Typography>
      <div style={{ flex: 1 }} />
      {user.admin && onEdit && <IconButton onClick={() => onEdit({ tipo: "treinamento", evento: treinamento })} size="small">
        <Edit fontSize="small" />
      </IconButton>
      }
      {user.admin && onRemove &&
        <IconButton onClick={() => onRemove(treinamento)} size="small">
          <Delete fontSize="small" />
        </IconButton>
      }
    </div>
    <Divider />
    {treinamento.tipo && <Item title="Tipo" value={treinamento.tipo} />}
    <Item title="Responsável" value={treinamento.responsavel} />
    {treinamentoAnterior && <Item title="Data do último treinamento" value={treinamentoAnterior.data.getDate().toSignificantDigits('dia') + "/" + (treinamentoAnterior.data.getMonth() + 1).toSignificantDigits('mes') + "/" + treinamentoAnterior.data.getFullYear().toString()} />}

    {/* Arquivo */}
    <div style={{ display: "flex", flexDirection: "row" }}>
      <Typography fontWeight={700} fontSize={14}>
        •&nbsp;Arquivo:&nbsp;
      </Typography>
      {
        treinamento.file ?
          <Link onClick={handleClick}>acesse aqui</Link> :
          <Typography fontSize={14}>nenhum arquivo</Typography>
      }
    </div>

    {/* Observações por último */}
    {treinamento.obs && <Item title="Observações" value={treinamento.obs} />}

  </Card>;

};

const Item = ({ title, value }: { title: string; value: string; }) => {
  return <div style={{ display: "flex", flexDirection: "row" }}>
    <Typography fontWeight={700} fontSize={14}>
      •&nbsp;{title}:&nbsp;
    </Typography>
    <Typography fontSize={14}>
      {value}
    </Typography>
  </div>;
};

